import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { onParams, PARAM_SORT } from '../../../common'
import { ProductCard, PagingContent, ParamOption } from '../../../components'
import { StoresContext } from '../../../provider/StoreProvider'

export const AssetHold: React.FC = observer(() => {
  const { myStore } = useContext(StoresContext)
  const [sortType, setSortType] = useState<PARAM_SORT>(PARAM_SORT.LATEST)
  const pagingStore = myStore.assetHoldPagingStore
  const [categoryIds, setCategoryIds] = useState<number>(0)

  useEffect(() => {
    pagingStore.load(undefined, true)
    setCategoryIds(0)
  }, [])

  useEffect(() => {
    onParams({
      store: pagingStore,
      sortType: sortType,
      categoryIds: categoryIds,
    })
  }, [sortType, categoryIds])

  const sortList = [
    {
      type: 'LATEST',
      title: '최근 거래순',
    },
    {
      type: 'REVENUE_RATE',
      title: '수익률순',
    },
    {
      type: 'COUNT',
      title: '보유 수량순',
    },
  ]

  return (
    <>
      <ParamOption
        sortData={{
          sortList: sortList,
          setSortType: setSortType,
        }}
        categoryData={{
          categoryIds: categoryIds,
          setCategoryIds: setCategoryIds,
        }}
      />
      <ContentsContainer>
        <PagingContent emptyText="조회 가능한 내역이 없습니다." pagingStore={pagingStore}>
          <ProductsContainer>
            {pagingStore.list.map((d, i) => (
              <ProductCard
                key={i}
                page={'ASSET_HOLD'}
                img={d.imageUri}
                artist={d.artist}
                title={d.name}
                routerLink={`/myPage/asset/${d.id}`}
                count={d.count} // 보유갯수 - count
                cost={d.averageCost} // 구입 평단가 - averageCost - 자산 변동률 계산시 필요
                currentCost={d.status === 'SALE' ? d.averageCost : d.currentCost} // 현재가 - 자산 변동률 계산시 필요
                status={d.status}
              />
            ))}
          </ProductsContainer>
        </PagingContent>
      </ContentsContainer>
    </>
  )
})

const ContentsContainer = styled.div`
  padding: 0 20px;
`

const ProductsContainer = styled.article`
  display: grid;
  grid-template-columns: repeat(2, minmax(160px, 100%));
  gap: 40px 15px;
`
